export default (state, { configurationError }) => ({
  ...state,
  isLoading: true,
  configurationError,
});
